import React from "react"
import { Navigate, useParams } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"

const ALL_FILES_SEGMENT = "all-files"

export function LegacyFilesRedirect() {
  const { id, albumId } = useParams<{ id: string; albumId?: string }>()
  if (!id) return null

  const routes = RoutesPaths.project.view(id)
  const target = !albumId
    ? routes.files()
    : albumId === ALL_FILES_SEGMENT
      ? routes.files()
      : routes.album(albumId)

  return <Navigate to={target} replace />
}
